<script>
	import { createEventDispatcher } from "svelte";
	import { uiText } from "../lib/uiText.js";
	import {
		doc,
		getDoc,
		collection,
		addDoc,
		setDoc,
		updateDoc,
		arrayUnion,
		onSnapshot,
		deleteField,
		serverTimestamp,
		increment,
		query,
		limit,
		orderBy,
		where,
	} from "firebase/firestore";
	import TeamView from "./TeamView.svelte";
	// import QrCode from './QRCode.svelte';

	const dispatch = createEventDispatcher();

	// export let auth;
	export let db;
	export let lang;
	export let loader;
	let ui = uiText(lang);
	$: lang,
		(ui = uiText(lang)),
		dispatch("setLang", { lang: lang, prefset: true });
	$: loader, dispatch("loader", loader), (ui = uiText(lang));
	$: screen, dispatch("screen", screen);
	$: teamsPerPage, sessionStorage.setItem("teamsPerPage", teamsPerPage);

	let screen = "input"; //input or showcase

	let openSet = {
		gid:
			sessionStorage.getItem("latestGID") === null
				? ""
				: sessionStorage.getItem("latestGID"),
		period_from: new Date().toISOString().split("T")[0],
		// period_from: new Date(),
		period_to: new Date().toISOString().split("T")[0],
		// period_to: new Date(),
	};

	let size = 16;
	let logo_size = 14;
	let hashtag_size = 12;

	let teams = [];
	let gameName = "";
	let hashtag = "#VGAdventures";

	let teamsPerPage =
		sessionStorage.getItem("teamsPerPage") === null
			? 10
			: sessionStorage.getItem("teamsPerPage");
	let showUsers = true;
	let showCurrentRiddle = false;
	let showFinish = false;
	let showTime = false;
	let showInOrder = false;

	let start = new Date("2025-01-01");
	let end = new Date("2026-01-01");

	// this.afs.collection('invoices', ref => ref
	//   .where('dueDate', '>', start)
	//   .where('dueDate', '<', end)
	// );

	//todo: add a second button and second type, where it shows all sessions, even those before the game has started.

	async function handleShowcase() {
		const showGameRef = query(
			collection(db, "sessions"),
			// limit(teamsPerPage),
			// where("orderGID", "==", openSet.gid),
			where("orderSessionStart", ">", start),
			where("orderSessionStart", "<", end),
			orderBy("orderSessionStart", "desc")
		);

		// 		.collection("sessions")
		// .orderBy("orderSessionCreated", "desc")

		sessionStorage.setItem("latestGID", openSet.gid);
		const unsubscribe = onSnapshot(showGameRef, (querySnapshot) => {
			let querySet = [];
			querySnapshot.forEach((doc) => {
				//
				// let from = Math
				// 	.round
				// 	// openSet.period_from.toISOString().split("T")[0].getTime() / 1000
				// 	();
				// let to = Math
				// 	.round
				// 	// openSet.period_to.toISOString().split("T")[0].getTime() / 1000
				// 	();
				// let session = doc.data().orderSessionCreated.seconds;

				// if (session > from && session < to) {
				querySet.push(doc.data());

				// с;
				// }

				// console.log(doc.data().orderSessionCreated.seconds);
				// console.log(openSet.period_from);
				// console.log(Math.round(openSet.period_from.getTime() / 1000));
				// // console.log(
				// 	Math.round(
				// 		openSet.period_to.toISOString().split("T")[0].getTime() / 1000
				// 	)
				// );

				//
				// querySet.push(doc.data());
			});
			teams = querySet;
			gameName = querySet[0].game.name;
		});
		if (openSet.gid.length > 3) {
			screen = "showcase";
			dispatch("screen", screen);
		}
	}

	function countHints(hintObject) {
		let scoreData = {};
		if (hintObject) {
			scoreData.usedHintsArray = Object.keys(hintObject.hintsUsed);
			scoreData.usedHintsTime = 0;
			scoreData.usedHintsCount = 0;

			scoreData.usedHintsArray.forEach((element) => {
				let keys = Object.keys(hintObject.hintsUsed[element]);
				// let values = Object.values(hintObject.hintsUsed[element]);
				// console.log(keys, values);
				scoreData.usedHintsCount = scoreData.usedHintsCount + keys.length;

				// values.forEach((element) => {
				// 	scoreData.usedHintsTime = scoreData.usedHintsTime + element;
				// });
			});
		} else {
			scoreData.usedHintsTime = 0;
			scoreData.usedHintsCount = 0;
		}
		return scoreData.usedHintsCount;
	}

	// HINTS ABOVE
	// ANSWERS BELOW

	// function countWrongs(answersObject) {
	// 	let answersData = {};
	// 	if (answersObject) {
	// 		answersData.wrongAnswersArray = Object.keys(answersObject.hintsUsed);
	// 		answersData.usedHintsCount = 0;

	// 		answersData.usedHintsArray.forEach((element) => {
	// 			let keys = Object.keys(hintObject.hintsUsed[element]);
	// 			let values = Object.values(hintObject.hintsUsed[element]);
	// 			// console.log(keys, values);
	// 			answersData.usedHintsCount = answersData.usedHintsCount + keys.length;

	// 			// values.forEach((element) => {
	// 			// 	answersData.usedHintsTime = answersData.usedHintsTime + element;
	// 			// });
	// 		});
	// 	} else {
	// 		answersData.usedHintsCount = 0;
	// 	}
	// 	return answersData.usedHintsCount;
	// }

	function countNestedElements(obj) {
		let totalCount = 0;

		for (const key in obj) {
			if (Array.isArray(obj[key])) {
				// If it's an array, count its elements
				totalCount += obj[key].length;
			} else if (typeof obj[key] === "object" && obj[key] !== null) {
				// If it's a nested object, recursively count its elements
				totalCount += countNestedElements(obj[key]);
			}
		}

		return totalCount;
	}

	// For future dev:
	// let start = new Date('2017-01-01');
	// let end = new Date('2018-01-01');

	// this.afs.collection('invoices', ref => ref
	//   .where('dueDate', '>', start)
	//   .where('dueDate', '<', end)
	// );
	// https://stackoverflow.com/questions/47000854/firestore-query-by-date-range
</script>

<!--  -->
<!--  -->
<!--  -->

{#if screen == "input"}
	<p class="mt-6 uppercase">VG Panel</p>
	<h1>Game Display</h1>

	<div class="flex flex-wrap">
		<div class="grid grow">
			<label for="open-gid">GID:</label>
			<input
				type="text"
				name="open-gid"
				id="open-gid"
				bind:value={openSet.gid}
				placeholder="Open Game ID"
				title="Game ID of the game you want to open"
			/>
		</div>
		<div class="grid grow">
			<label for="open-gid">#:</label>
			<input
				type="text"
				name="open-gid"
				id="open-gid"
				bind:value={hashtag}
				placeholder="#ВътрешенГлас"
				title="#Hashtag to be shown at the bottom"
			/>
		</div>
	</div>
	<div class="flex flex-wrap">
		<div class="grid grow">
			<label for="period_from">Period from:</label>
			<input
				type="date"
				name="period_from"
				id="period_from"
				bind:value={openSet.period_from}
				placeholder="Inactive before"
				title="Inactive before"
			/>
		</div>

		<div class="grid grow">
			<label for="period_to">Period to:</label>
			<input
				type="date"
				name="period_to"
				id="period_to"
				bind:value={openSet.period_to}
				placeholder="Inactive after"
				title="Inactive after"
			/>
		</div>
	</div>

	<!-- <p>QR Content: {codeValue ? codeValue : 'Unset - Open a game to change'}</p> -->
	<!-- <button on:click={handleOpenGame}
        ><i class="fa-solid fa-folder-open" data-position="left" />Open Game</button
    > -->
	<button on:click={handleShowcase}
		><i class="fa-solid fa-stopwatch" data-position="left" />Compile Data</button
	>
	<!-- disabled={openSet.gid.length < 3 ? true : false} -->
{:else if screen == "showcase"}
	<div
		class="flex flex-wrap w-screen gap-12 p-12 -mx-4 -mt-8 place-content-center"
		id="showcase"
		style={"font-size:" + size + "px"}
	>
		<div
			class="grid content-center justify-start"
			style={"font-size:" + logo_size + "px"}
		>
			<img
				class="max-w-full h-[5em]"
				src={lang === "bg" ? "/img/svg/logo-bg.svg" : "/img/svg/logo-en.svg"}
				alt={ui.game.footer.vendor}
			/>
		</div>
		<div
			class="content-center justify-end hidden ml-auto text-right sm:grid"
			style={"font-size:" + hashtag_size + "px;"}
		>
			<h1 class="font-light">{gameName}</h1>
			<h1 class="font-light text-teal">{hashtag}</h1>
		</div>
	</div>
	{#if false}
		<div
			class="grid flex-wrap gap-2 pb-8 sm:flex"
			style={showInOrder ? "flex-direction:column-reverse" : ""}
		>
			{#each teams as team}
				<!-- {team.session.team_name} -->
				<TeamView
					{team}
					{showUsers}
					{showCurrentRiddle}
					{showFinish}
					{showTime}
					{showInOrder}
				/>

				<!-- <TeamView></TeamView> -->
			{/each}
		</div>
	{/if}

	<table>
		<tr>
			<th>Име на играта</th>
			<th>Име на отбора</th>
			<th>Играчи в отбора</th>
			<th>Решени нормални</th>
			<th>Решени бонус</th>
			<th>Използвани насоки</th>
			<th>Грешни отговори</th>
			<th>Дата</th>
			<th>Начало</th>
			<th>Край</th>
			<th>Продължителност</th>
		</tr>
		{#each teams as team}
			<tr>
				<td>{team.game.name}</td>
				<td>{team.session.team_name}</td>
				<td>{Object.keys(team.session.players).length}</td>
				<td>{team.session.normal_riddles_solved}</td>
				<td>{team.session.bonus_riddles_solved}</td>
				<td>{countHints(team.hints)}</td>
				<td>{countNestedElements(team.wrongAnswers)}</td>
				<td>{team.session.sessionStart.toDate().toLocaleDateString()}</td>
				<td>{team.session.sessionStart.toDate().toLocaleTimeString()}</td>
				<td
					>{team.session.sessionEnd
						? team.session.sessionEnd.toDate().toLocaleTimeString()
						: "DNF"}</td
				>
				<!-- 
                Дата
Час
Отбор
Играчи в отбора
Насоки
Грешни отговори
Игра
начало
край
продължителност
 -->
			</tr>
		{/each}
	</table>

	<div tabindex="0" class=" opacity-0">Tab In</div>

	<div
		class="fixed bottom-0 left-0 p-4 text-blue-100 bg-white opacity-0 hover:opacity-100 display-panel"
	>
		<i class="mr-4 fa-solid fa-text-height" />
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-plus"
			on:click={() => (size = size + 1)}
			tabindex="0"
		/>
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-minus"
			on:click={() => (size = size - 1)}
			tabindex="0"
		/>
		|
		<i class="mx-4 fa-brands fa-blogger-b" />
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-plus"
			on:click={() => (logo_size = logo_size + 1)}
			tabindex="0"
		/>
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-minus"
			on:click={() => (logo_size = logo_size - 1)}
			tabindex="0"
		/>

		|
		<i class="mx-4 fa-solid fa-hashtag" />
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-plus"
			on:click={() => (hashtag_size = hashtag_size + 1)}
			tabindex="0"
		/>
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-minus"
			on:click={() => (hashtag_size = hashtag_size - 1)}
			tabindex="0"
		/>

		|
		<i class="mx-4 fa-solid fa-qrcode" />
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-pen"
			on:click={() => (screen = "input")}
			tabindex="0"
		/>
		|
		<i class="mx-4 fa-solid fa-list-ol" />
		<input
			type="number"
			min="1"
			size="2"
			bind:value={teamsPerPage}
			tabindex="0"
		/>

		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-arrow-rotate-right"
			on:click={handleShowcase}
			tabindex="0"
		/>

		<!-- <i
            class="p-2 text-white bg-blue-100 fa-solid fa-square-plus"
            on:click={() => (teamsPerPage = teamsPerPage + 5)}
        />
        <i
            class="p-2 text-white bg-blue-100 fa-solid fa-square-minus"
            on:click={() => (teamsPerPage = teamsPerPage - 5)}
        /> -->
		|
		<div on:click={() => (showUsers = !showUsers)} class="inline" tabindex="0">
			<i class="mx-4 fa-solid fa-user-ninja" />

			<i
				class={!showUsers
					? "p-2 text-white bg-blue-100 fa-solid fa-square-check"
					: "p-2 text-white bg-blue-100 fa-solid fa-square-xmark"}
			/>
		</div>
		|
		<div
			on:click={() => (showCurrentRiddle = !showCurrentRiddle)}
			tabindex="0"
			class="inline"
		>
			<i class="mx-4 fa-solid fa-puzzle-piece" />
			<i
				class={showCurrentRiddle
					? "p-2 text-white bg-blue-100 fa-solid fa-square-check"
					: "p-2 text-white bg-blue-100 fa-solid fa-square-xmark"}
			/>
		</div>
		|
		<div
			on:click={() => (showFinish = !showFinish)}
			class="inline"
			tabindex="0"
		>
			<i class="mx-4 fa-solid fa-flag-checkered" />
			<i
				class={showFinish
					? "p-2 text-white bg-blue-100 fa-solid fa-square-check"
					: "p-2 text-white bg-blue-100 fa-solid fa-square-xmark"}
			/>
		</div>

		|
		<div on:click={() => (showTime = !showTime)} class="inline" tabindex="0">
			<i class="mx-4 fa-solid fa-stopwatch" />
			<i
				class={showTime
					? "p-2 text-white bg-blue-100 fa-solid fa-square-check"
					: "p-2 text-white bg-blue-100 fa-solid fa-square-xmark"}
			/>
		</div>

		<!-- <i class="fa-solid fa-stopwatch"></i> -->

		|
		<div
			on:click={() => (showInOrder = !showInOrder)}
			class="inline"
			tabindex="0"
		>
			<i class="mx-4 fa-solid fa-trophy" />
			<i
				class={showInOrder
					? "p-2 text-white bg-blue-100 fa-solid fa-square-check"
					: "p-2 text-white bg-blue-100 fa-solid fa-square-xmark"}
			/>
		</div>
	</div>
	<div tabindex="0" class=" opacity-0">Tab Out</div>
{/if}

<style>
	#showcase {
		grid-template-columns: auto 1fr;
		grid-template-rows: 1fr auto 1fr;
	}
	/* #showcase .qr {
    box-shadow: #093986 10px 10px 0;
  } */
	#showcase h1 {
		font-size: 3em;
		line-height: normal;
	}
	/* #showcase h1.text-6xl {
    font-size: 5em;
    line-height: normal;
    filter: drop-shadow(10px 10px 0px #093986);
    text-transform: uppercase;
    font-weight: 900;
  } */

	.display-panel:focus-within {
		opacity: 100;
		background-color: lightblue;
	}
</style>
